import React, { useState, useEffect } from 'react';
import { Backdrop, Box, Typography, CircularProgress, LinearProgress } from '@mui/material';

const UploadLoader = ({ isUploading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let progressInterval;
    
    if (isUploading) {
      setProgress(0);
      
      // Simulated continuous progress bar animation
      progressInterval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 95) return prev;
          // As it gets closer to 100, slow down the progress increment
          const increment = Math.max(0.5, (95 - prev) * 0.05);
          return prev + increment;
        });
      }, 500);
    } else {
      // Complete the progress visually just before it hides
      setProgress(100);
    }

    return () => {
      clearInterval(progressInterval);
    };
  }, [isUploading]);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: 99999, // Very high z-index to sit above everything
        backdropFilter: 'blur(6px)', // Slight dark blur background
        backgroundColor: 'rgba(17, 24, 39, 0.75)',
        display: 'flex',
        flexDirection: 'column',
      }}
      open={isUploading}
    >
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#FFFFFF',
          padding: '40px 60px',
          borderRadius: '24px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          maxWidth: '420px',
          width: '90%'
        }}
      >
        <CircularProgress 
          size={56} 
          thickness={4.5} 
          sx={{ color: '#6366F1', mb: 3 }} 
        />
        
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#111827', 
            fontWeight: 800,
            mb: 1.5,
            fontFamily: '"Inter", "SF Pro Display", -apple-system, sans-serif'
          }}
        >
          Processing Images...
        </Typography>
        
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#6B7280', 
            mb: 4, 
            textAlign: 'center',
            fontFamily: '"Inter", "SF Pro Display", -apple-system, sans-serif',
            lineHeight: 1.5
          }}
        >
          Please wait while we upload your content and secure the listing. This might take a moment.
        </Typography>

        <Box sx={{ width: '100%' }}>
          <LinearProgress 
            variant="determinate" 
            value={progress} 
            sx={{ 
              height: 8, 
              borderRadius: 4,
              backgroundColor: '#EEF2FF',
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#6366F1',
                borderRadius: 4,
                transition: 'transform 0.5s ease'
              }
            }} 
          />
          <Typography 
            variant="caption" 
            sx={{ 
              display: 'block', 
              textAlign: 'right', 
              mt: 1.5, 
              color: '#9CA3AF',
              fontWeight: 600,
              fontFamily: '"Inter", "SF Pro Display", -apple-system, sans-serif'
            }}
          >
            {Math.round(progress)}%
          </Typography>
        </Box>
      </Box>
    </Backdrop>
  );
};

export default UploadLoader;
